import { routes } from '../router'

export default {
  data () {
    return {
      routes
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/routes.js